import React, { createContext, useEffect, useReducer, useState } from 'react';
import { iState } from "./interfaces";

import GameReducer, { INITIAL_STATE } from './GameReducer';

interface IProps {
  children: any;
  INITIAL_STATE: any;
}

export const GameContext = createContext<{
  state: iState;
  dispatch: React.Dispatch<any>;
}>({
  state: INITIAL_STATE,
  dispatch: () => null
});

export default function GameContextProvider({ children, INITIAL_STATE }: IProps) {

  const [state, dispatch] = useReducer(GameReducer, INITIAL_STATE);
  //console.log("gameID:", gameID);
  return (
    <GameContext.Provider value={{ state, dispatch }}>
      {children}
    </GameContext.Provider>
  );
}

